import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Maintenance, MaintenanceStatusProperties } from '../../../../class/Maintenance';
import { MaintenanceService } from '../../../../services/maintenance.service';
import { DonutValue } from '../../library/donut/donut.component';

import { TranslatePipe } from '@ngx-translate/core';
import { TitleComponent } from '../../../layout/title-section/title/title.component';
import { DonutComponent } from '../../library/donut/donut.component';
import { StatusCardComponent } from '../../library/status-card/status-card.component';

interface MaintenanceState {
  count?: number;
  percent?: number;
  label: string;
}

@Component({
  selector: 'app-maintenance-chart',
  templateUrl: './maintenance-chart.component.html',
  styleUrls: ['./maintenance-chart.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, StatusCardComponent, DonutComponent, TitleComponent],
})
export class MaintenanceChartComponent implements OnDestroy {
  public maintenanceList: Maintenance[];

  @Input() mode: 'tab' | 'widget' = 'tab';

  @Input() set maintenanceListProvided(maintenanceListProvided: Maintenance[]) {
    this.maintenanceList = maintenanceListProvided;
    if (this.maintenanceList) {
      this.colorsStates = this.statesMaintenances.map(state => MaintenanceStatusProperties[state].color);
      this._setDataMaintenancesGraph(this.maintenanceList);
      this.computeDonutValues();
    }
  }

  private _maintenanceService = inject(MaintenanceService);
  private _translate = inject(TranslateService);

  public statesMaintenances = [0, 1, 2, 3] as const;
  public totalMaintenanceTodo: number | null = null;
  public donutValues: DonutValue[] = [];
  public colorsStates = [];

  public statesMaintenancesGraph: Record<(typeof this.statesMaintenances)[number], MaintenanceState> = {
    0: { label: MaintenanceStatusProperties[0].name },
    1: { label: MaintenanceStatusProperties[1].name },
    2: { label: MaintenanceStatusProperties[2].name },
    3: { label: MaintenanceStatusProperties[3].name },
  };

  private _destroy$ = new Subject<void>();

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public computeDonutValues() {
    this.donutValues = this.statesMaintenances.map((state, index) => {
      return {
        label: this._translate.instant(MaintenanceStatusProperties[state].name),
        value: this.statesMaintenancesGraph[state].percent * 100,
        color: this.colorsStates[index],
      };
    });
  }

  private _setDataMaintenancesGraph(maintenanceList: Maintenance[]) {
    this.totalMaintenanceTodo = maintenanceList.length;
    for (const state in this.statesMaintenances) {
      this.statesMaintenancesGraph[state].count = this._countByState(Number(state));
      this.statesMaintenancesGraph[state].percent = this._computePercentByState(Number(state));
    }
  }

  private _countByState(state: number) {
    return this.maintenanceList.filter(maintenance => maintenance.status.value === state).length;
  }

  private _computePercentByState(state: number) {
    return this.totalMaintenanceTodo
      ? this.maintenanceList.filter((maintenance: Maintenance) => maintenance.status.value === state).length /
          this.totalMaintenanceTodo
      : 0;
  }

  public trackStatus(index: number, elem: 0 | 1 | 2 | 3) {
    return 'STATUS_' + index + '_' + elem;
  }
}
